import { createFileRoute } from "@tanstack/react-router";
import ResearchAndInvestigationalPage from "@/pages/ResearchAndInvestigationalPage";
export const Route = createFileRoute(
  "/research-and-investigational-treatments",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Research & Investigational Treatments | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "Clear distinction between FDA-cleared TMS indications and emerging, investigational research. Understand what is established vs. experimental in.",
        },
        {
          property: "og:title",
          content: "Research & Investigational Treatments | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "Clear distinction between FDA-cleared TMS indications and emerging, investigational research. Understand what is established vs. experimental in.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/research-and-investigational-treatments",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/research-and-investigational-treatments",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ResearchAndInvestigationalPage />;
}
